var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgChooseAmount = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m41.536 40.783 20.79 18.248L52.137 59a4 4 0 0 0-2.976 1.313l-7.624 8.413V40.783Zm-4 0c0-3.44 4.053-5.275 6.639-3.006l20.79 18.248c2.778 2.438 1.046 7.017-2.65 7.006L52.123 63 44.5 71.412c-2.458 2.711-6.964.973-6.964-2.686V40.783Zm2.074-21.656a2 2 0 0 1 .263 2.816l-9.666 11.666a2 2 0 0 1-2.914.178l-6-5.666a2 2 0 0 1 2.747-2.908l4.448 4.201 8.305-10.023a2 2 0 0 1 2.816-.264Z",
    fill: "#2E3641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 19.334c0-5.523 4.477-10 10-10h43.333c5.523 0 10 4.477 10 10v17.809c0 5.523-4.477 10-10 10h-.476a2 2 0 0 1 0-4h.476a6 6 0 0 0 6-6v-17.81a6 6 0 0 0-6-6H18a6 6 0 0 0-6 6v17.81a6 6 0 0 0 6 6h12.095a2 2 0 0 1 0 4H18c-5.523 0-10-4.477-10-10v-17.81Z",
    fill: "#2E3641"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChooseAmount);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chooseAmount.2c69a23a3e17a4aa4b83fc016a350a7d.svg";